<template>
  <div class="loadRateOuter">
    <Title :title="'站点负荷率分布'" :isActiveSec="true"></Title>
    <div class="flex">
      <Pie :cdata="cdata" :width="style.width" :height="style.height"/>
    </div>
  </div>
</template>

<script>
import Pie from '../pie'
import Title from '../../title.vue'
import { indexLeft } from '@/api/indexLeft';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      cdata: {
        id:"loadRatePie",
        data: [
          {value: 0, name: '80%以上'},
          {value: 0, name: '60-80%'},
          {value: 0, name: '40-60%'},
          {value: 0, name: '40%以下'},
        ]   
      },
      userList:[{},{}],
      style:{
        width:'500',
        height:'180'
      }
    };
  },
  components: {
    Pie,
    Title
  },
  mounted () {
    
  },
  methods: {
    getData(data){
      this.selectStationLoadRateDistribute(data);
    },
    selectStationLoadRateDistribute(data={}){
      let _this = this;
        let params = {};
				if(data){
				//建设中--省市区
				params = {
					"enCode":"TiDB-shengshiqu-zhandianfuhelvfenbu",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-zhandianfuhelvfenbu"//全国
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          this.cdata.data = res;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
.loadRateOuter{
  width:500px;
  overflow: hidden;
}
.barrery-inner{
  // margin-right:12px;
  width: 94px;
  padding: 0 9px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  img{
    width:30px;
    height:30px;
  }
  .price{

  }
  .count{

  }
}
</style>